import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ContactForm from './ContactForm';

const ContactOptions = ({ show, handleClose }) => {
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleWhatsApp = () => {
    window.open('https://wa.me/556540427638', '_blank');
  };

  const handleEmailSubmit = async (formData) => {
    try {
      await fetch('https://webhook.gaotech.com.br/webhook/site-gao', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      setShowEmailForm(false);
      setShowSuccess(true);
    } catch (error) {
      console.error('Erro ao enviar formulário:', error);
      setShowEmailForm(false);
      setShowError(true);
    }
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    handleClose();
  };

  const handleErrorClose = () => {
    setShowError(false);
    handleClose();
  };

  if (showEmailForm) {
    return (
      <ContactForm 
        show={show} 
        handleClose={() => {
          setShowEmailForm(false);
          handleClose();
        }}
        onSubmit={handleEmailSubmit}
      />
    );
  }

  if (showSuccess) {
    return (
      <Modal show={true} onHide={handleSuccessClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Mensagem Enviada!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Sua mensagem foi enviada com sucesso!</p>
          <p>Em breve nossa Equipe entrará em contato.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSuccessClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  if (showError) {
    return (
      <Modal show={true} onHide={handleErrorClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Email Congestionado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Email congestionado, tente chamar no WhatsApp</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleErrorClose}>
            Fechar
          </Button>
          <Button variant="success" onClick={handleWhatsApp}>
            Abrir WhatsApp
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Como prefere falar conosco?</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column gap-3">
        <Button 
          variant="success" 
          size="lg" 
          onClick={handleWhatsApp}
          className="w-100"
        >
          Chamar no WhatsApp
        </Button>
        <Button 
          variant="primary" 
          size="lg" 
          onClick={() => setShowEmailForm(true)}
          className="w-100"
        >
          Enviar uma mensagem de Email
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default ContactOptions;
